var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"value":_vm.value,"options":_vm.options[_vm.settingKey]},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }